var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyAgents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6667 80H133.333V113.333C133.333 128.061 121.394 140 106.667 140H53.3333C38.6057 140 26.6667 128.061 26.6667 113.333V80ZM40 93.3333V113.333C40 120.697 45.9695 126.667 53.3333 126.667H106.667C114.03 126.667 120 120.697 120 113.333V93.3333H40Z",
    fill: "#22252C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 66.6667C20 55.621 28.9543 46.6667 40 46.6667H120C131.046 46.6667 140 55.621 140 66.6667V73.3333C140 84.379 131.046 93.3333 120 93.3333H40C28.9543 93.3333 20 84.379 20 73.3333V66.6667ZM40 60C36.3181 60 33.3333 62.9848 33.3333 66.6667V73.3333C33.3333 77.0152 36.3181 80 40 80H120C123.682 80 126.667 77.0152 126.667 73.3333V66.6667C126.667 62.9848 123.682 60 120 60H40Z",
    fill: "#22252C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6667 40C46.6667 28.9543 55.621 20 66.6667 20C71.789 20 76.4616 21.9257 80 25.0926C83.5384 21.9257 88.211 20 93.3333 20C104.379 20 113.333 28.9543 113.333 40C113.333 51.0457 104.379 60 93.3333 60H86.6667V140H73.3333V60H66.6667C55.621 60 46.6667 51.0457 46.6667 40ZM73.3333 46.6667V40C73.3333 36.3181 70.3486 33.3333 66.6667 33.3333C62.9848 33.3333 60 36.3181 60 40C60 43.6819 62.9848 46.6667 66.6667 46.6667H73.3333ZM86.6667 40V46.6667H93.3333C97.0152 46.6667 100 43.6819 100 40C100 36.3181 97.0152 33.3333 93.3333 33.3333C89.6514 33.3333 86.6667 36.3181 86.6667 40Z",
    fill: "#22252C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAgents);
export default __webpack_public_path__ + "static/media/empty-agents.32dd02ba4c52d4df5339df024e89fe5b.svg";
export { ForwardRef as ReactComponent };